// src/tattoo/ProjectHeart.jsx
import React from "react";
import { useSnapshot as useRxSnap } from "valtio";
import {
  reactionsStore,
  getVote,
  toggleVote,
  preloadReactionCounts,
} from "./reactionsState";
import { subscribeReactions } from "./reactionsRealtime";

/**
 * Project-level reaction button.
 * Uses the same reactions pipeline as per-layer votes.
 */
export default function ProjectHeart({
  projectId = "project-global",
  className = "",
}) {
  // subscribe so this re-renders when counts change
  useRxSnap(reactionsStore);

  // make sure counts are loaded (just like LayersPanel does for layers)
  React.useEffect(() => {
    preloadReactionCounts([projectId]); // still needed
  
    // subscribe for live updates
    const off = subscribeReactions(projectId);
    return () => off();
  }, [projectId]);
  const vote = getVote(projectId) || { mine: false, count: 0 };

  return (
    <button
      type="button"
      className={`tt-btn ${className} ${vote.mine ? "is-on" : ""}`}
      title={
        vote.mine
          ? "Remove your like for this project"
          : "Like this overall project"
      }
      onClick={() => toggleVote(projectId, "local")}
      style={{ minWidth: 42 }}
    >
      {vote.mine ? "❤️" : "🤍"} {vote.count || 0}
    </button>
  );
}